import { RouteConfig } from 'vue-router'

import bookingFunnelGuard from '@/router/guards/bookingFunnel'
import bookingFunnelServicesGuard from '@/router/guards/bookingFunnelServices'
import isAuthenticatedGuard from '@/router/guards/isAuthenticated'

const CSBookingFunnelServices = () =>
  import(
    /* webpackChunkName: "bookingFunnel" */
    '@/components/organisms/bookingFunnelSteps/CSBookingFunnelServices.vue'
  )
const CSBookingFunnelCareReceiver = () =>
  import(
    /* webpackChunkName: "bookingFunnel" */
    '@/components/organisms/bookingFunnelSteps/CSBookingFunnelCareReceiver.vue'
  )
const CSBookingFunnelSchedule = () =>
  import(
    /* webpackChunkName: "bookingFunnel" */
    '@/components/organisms/bookingFunnelSteps/CSBookingFunnelSchedule.vue'
  )
const CSBookingFunnelPay = () =>
  import(
    /* webpackChunkName: "bookingFunnel" */
    '@/components/organisms/bookingFunnelSteps/CSBookingFunnelPay.vue'
  )

const BookingFunnel = () =>
  import(
    /* webpackChunkName: "bookingFunnel" */
    '@/views/bookingFunnel/CSBookingFunnel.vue'
  )

const bookingFunnelRoutes: Array<RouteConfig> = [
  {
    path: '/buchung',
    name: 'bf-root',
    component: BookingFunnel,
    beforeEnter: bookingFunnelGuard,
    children: [
      {
        path: 'services',
        name: 'bf-services',
        component: CSBookingFunnelServices,
        // beforeEnter: bookingFunnelServicesGuard,
        meta: {
          hideTopSidebar: true,
          bookingFunnelSubPage: 'services', // for stepper header
          layout: 'booking-funnel',
          gtm: 'booking funnel step 1 - service page',
          translateKey: 'PAGETITLE_GERMAN_SERVICES_BOOKINGFUNNEL',
        },
      },
      {
        path: 'profilerstellung',
        name: 'bf-care-receiver',
        component: CSBookingFunnelCareReceiver,
        meta: {
          bookingFunnelSubPage: 'profilerstellung', // for stepper header
          layout: 'booking-funnel',
          gtm: 'booking funnel step 2 - carereceiver profile',
          translateKey: 'PAGETITLE_GERMAN_CARERECEIVER_BOOKINGFUNNEL',
        },
        beforeEnter: isAuthenticatedGuard,
      },
      {
        path: 'terminplanung',
        name: 'bf-schedule',
        component: CSBookingFunnelSchedule,
        meta: {
          bookingFunnelSubPage: 'terminplanung', // for stepper header
          layout: 'booking-funnel',
          gtm: 'booking funnel step 3 - scheduling',
          translateKey: 'PAGETITLE_GERMAN_SCHEDULE_BOOKINGFUNNEL',
        },
        beforeEnter: isAuthenticatedGuard,
      },
      {
        path: 'bezahlung',
        name: 'bf-payment',
        component: CSBookingFunnelPay,
        meta: {
          bookingFunnelSubPage: 'bezahlung', // for stepper header
          layout: 'booking-funnel',
          gtm: 'booking funnel step 4 - payment',
          translateKey: 'PAGETITLE_GERMAN_PAYMENT_BOOKINGFUNNEL',
        },
        beforeEnter: isAuthenticatedGuard,
      },
    ],
  },
]

export default bookingFunnelRoutes
